<template>
    <div class="app-main" id="srm-index">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card mg-b5">
            <div class="el-menu-box">
                <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
                    <el-menu-item
                        v-for="item in menus"
                        :key="item.key"
                        :index="item.key">
                            {{item.name}}({{item.count}})
                    </el-menu-item>
                </el-menu>
            </div>
        </el-card>
        <div class="order-wrap">
            <OrderTable v-if="activeIndex == 'all'" pageFlag="all"/>
            <OrderTable v-if="activeIndex == 'onJoin'" pageFlag="onJoin"/>
            <OrderTable v-if="activeIndex == 'giveUp'" pageFlag="giveUp"/>
            <OrderTable v-if="activeIndex == 'joining'" pageFlag="joining"/>
            <OrderTable v-if="activeIndex == 'submit'" pageFlag="submit"/>
            <OrderTable v-if="activeIndex == 'bidding'" pageFlag="bidding"/>
            <OrderTable v-if="activeIndex == 'unBidding'" pageFlag="unBidding"/>
        </div>
    </div>
</template>
<script>
// import srmAll from './srmAll'
// import inquiry from './inquiry'
// import inquiryIng from './inquiryIng'
import OrderTable from './OrderTable'
import { getStatisticsGys } from '@/api/srm/inquiry.js'
export default {
    components:{
        OrderTable
    },
    data(){
        return {
            activeIndex:'all',
            menus:[
                {key:'all',name:'全部',count:0},
                {key:'onJoin',name:'待参与',count:0},
                {key:'giveUp',name:'已放弃',count:0},
                {key:'joining',name:'报价中',count:0},
                {key:'submit',name:'报价已提交',count:0},
                {key:'bidding',name:'已中标',count:0},
                {key:'unBidding',name:'未中标',count:0},
            ],
        }
    },
    created(){
        if(this.checkRole('gys_role')){
            this.getStatisticsGys()
        }
    },
    methods:{
        async getStatisticsGys() {
            let _this = this;
            const { data: res } = await getStatisticsGys({});
            if (res.code == 0) {
                let newMenus = [...this.menus];
                let sta = res.data.statistics || [];
                sta.forEach((item)=>{
                    if(item.code == 0){
                        newMenus[0].count = item.count;
                    }
                    if(item.code == 1){
                        newMenus[1].count = item.count;
                    }
                    if(item.code == 2){
                        newMenus[2].count = item.count;
                    }
                    if(item.code == 3){
                        newMenus[3].count = item.count;
                    }
                    if(item.code == 4){
                        newMenus[4].count = item.count;
                    }
                    if(item.code == 5){
                        newMenus[5].count = item.count;
                    }
                    if(item.code == 6){
                        newMenus[6].count = item.count;
                    }
                })
                this.menus = newMenus;
            }
        },
        handleSelect(key){
            this.activeIndex = key;
        },
    }
}
</script>
<style lang="scss">
    #srm-index{
        .el-menu-box{
            width:100%;
        }
    }
</style>


